import React from 'react'
import type { BootstrapData } from '@/types'

const BootstrapDataContext = React.createContext<BootstrapData>(
  {} as BootstrapData
)

export default BootstrapDataContext
